import getErrorMessage from '@/utils/get-error-message'
import { Notify, Toast } from 'vant'
import AppTheme from '@/theme/themes'

const ignoreKeys = ['ignore']

async function loading(promise, title = '', successText) {
  try {
    Toast.loading({
      message: title,
      duration: 0,
      forbidClick: true,
      className: 'wb-loading',
      overlay: true,
      icon: AppTheme.getThemeAsset('loadingAnima')
    })
    const res = await promise
    Toast.clear(true)
    if (successText) await Toast.success(successText)
    return res
  } catch (error) {
    Toast.clear(true)
    const errorMessage = getErrorMessage(error)
    if (ignoreKeys.every(key => !errorMessage.includes(key))) await Notify({ type: 'warning', message: errorMessage })
    throw error
  }
}

function loadingDecorator(...args) {
  return function(target, name, descriptor) {
    const func = descriptor.value
    descriptor.value = function(...funcArgs) {
      return loading(func.apply(this, funcArgs), ...args)
    }
  }
}

export default function(...args) {
  if (typeof args[0] === 'function') {
    // 被当作普通函数调用 且 args[0] 是普通函数
    return
  } else if (typeof args[0].then === 'function') {
    // 被当作普通函数调用 且 args[0] 是 promise
    return loading(...args)
  } else if (args.length === 3) {
    // 被当作装饰器使用 legacy 模式 args 为[target, name, descriptor]
    return loadingDecorator()(...args)
  } else {
    return loadingDecorator(...args) // 被当做装饰器并传参使用 args 是参数
  }
}
